export default __webpack_public_path__ + "static/media/47SJ63.c12c7af8.png";